// Локальная копия токенов и функций маскирования из vue-the-mask, адаптированная для Vue 3
export const defaultTokens = {
    '#': {pattern: /\d/},
    'X': {pattern: /[0-9a-zA-Z]/},
    'S': {pattern: /[a-zA-Z]/},
    'A': {pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleUpperCase()},
    'a': {pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleLowerCase()},
    '!': {escape: true},
};

function maskit(value, mask, masked = true, tokens = defaultTokens) {
    value = value || '';
    mask = mask || '';
    let iMask = 0;
    let iValue = 0;
    let output = '';

    while (iMask < mask.length && iValue < value.length) {
        let cMask = mask[iMask];
        const masker = tokens[cMask];
        const cValue = value[iValue];

        if (masker && !masker.escape) {
            if (masker.pattern.test(cValue)) {
                output += masker.transform ? masker.transform(cValue) : cValue;
                iMask++;
            }
            iValue++;
        } else {
            if (masker && masker.escape) {
                iMask++; // пропускаем escape-символ
                cMask = mask[iMask];
            }
            if (masked) output += cMask;
            if (cValue === cMask) iValue++;
            iMask++;
        }
    }

    let restOutput = '';
    while (iMask < mask.length && masked) {
        const cMask = mask[iMask];
        if (tokens[cMask]) {
            restOutput = '';
            break;
        }
        restOutput += cMask;
        iMask++;
    }

    return output + restOutput;
}

function dynamicMask(masker, masks, tokens = defaultTokens) {
    masks = masks.sort((a, b) => a.length - b.length);
    return function (value, mask, masked = true) {
        let i = 0;
        while (i < masks.length) {
            const currentMask = masks[i];
            i++;
            const nextMask = masks[i];
            if (!(nextMask && masker(value, nextMask, true, tokens).length > currentMask.length)) {
                return masker(value, currentMask, masked, tokens);
            }
        }
        return '';
    };
}

export function maskValue(value, mask, masked = true, tokens = defaultTokens) {
    const sourceValue = value == null ? '' : String(value);
    return Array.isArray(mask)
        ? dynamicMask(maskit, mask, tokens)(sourceValue, mask, masked, tokens)
        : maskit(sourceValue, mask, masked, tokens);
}
